<template>
  <div class="top_box">
    <figure class="box" v-if="props.returnData">
      <div class="big_title">{{ content.title }}</div>
      <img
        v-if="content.navigationImgUrl"
        class="img1"
        :src="content.navigationImgUrl"
        alt="Your Image"
      />
      <figcaption
        class="article"
        v-html="normalizeRichText(content.content)"
      ></figcaption>
    </figure>
    <div class="icon_list" v-if="iconList.length > 0">
      <div
        class="icon_item"
        v-for="(item, index) in iconList.slice(0, 4)"
        :key="'icon' + index"
      >
        <img class="img_box" :src="item.icon" alt="" />
        <div class="item_box">
          <div class="word_box">
            {{ item.value }}<span class="danwei">{{ item.danwei }}</span>
          </div>
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import api from "@/api/api";
import { normalizeRichText } from "@/utils/richText";
let props = defineProps(["returnData"]);
let content = ref("");
let iconList = ref([]);

let getPageValue = async () => {
  let api2 = api.getNumberListInfo({ resourceId: 77 });
  let api3 = api.getPageConfigDetail(76);
  let [res2, res3] = await Promise.all([api2, api3]);
  // resourceId 77 无数据时接口返回空 body，res.data 是空串，直接 sort 会抛错并中断后面的集团简介取数
  if (res2.code === "0" && res2.res.data) {
    iconList.value = [];
    let sortData = res2.res.data.sort((a, b) => a.orderIndex - b.orderIndex);
    sortData.forEach((item) => {
      iconList.value.push({
        icon: item.icon,
        value: item.number,
        danwei: item.unit,
        title: item.title,
      });
    });
  }
  if (res3.code === "0") {
    content.value = res3.res.data;
  }
};
getPageValue();
</script>
<style lang="less" scoped>
.big_title {
  height: 5.27vh;
  font-weight: 600;
  font-size: 48px;
  line-height: 5.27vh;
  text-align: left;
  font-style: normal;
  color: #333333;
  margin-bottom: 3.38vh;
  font-family: PingFangSC, PingFang SC;
}
.top_box {
  width: 100%;
  .box {
    .img1 {
      float: right;
      width: 35.73vw;
      height: 35.74vh;
      margin: 1.02vh 0px 1.25vw 5.82vh;
      border-radius: 8px;
    }
    .article {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      // line-height: 2.99vh;
      line-height: 38px;
      text-align: justify;
      font-style: normal;
    }
  }
  .icon_list {
    width: 100%;
    padding: 72px 0px 133px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon_item {
      display: flex;
      align-items: center;
      .img_box {
        width: 3.33vw;
        height: 5.65vh;
        // width: 64px;
        // height: 61px;
        margin-right: 1.65vh;
      }
      .item_box {
        flex: 1;
        .word_box {
          // height: 5.51vh;
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          font-size: 3.125vw;
          color: #333333;
          // line-height: 5.51vh;
          text-align: justify;
          font-style: normal;
          span {
            // height: 2.2vh;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 1.042vw;
            color: #333333;
            // line-height: 1.46vh;
            text-align: justify;
            font-style: normal;
            margin-left: 0.83vw;
          }
        }
        .title {
          // height: 2.2vh;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 1.042vw;
          color: #333333;
          // line-height: 2.2vh;
          text-align: justify;
          font-style: normal;
        }
      }
    }
  }
}
</style>
